<template>
    <!-- 
    1.화면ID    : MCF_NT_001
    2.화면명    : News@Report등록
    3.작성자    : 최원경 부장
    4.화면설명  : News@Report를 등록 관리한다. 
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    --> 
    <div class="content-wrap">
  
      <div class="register-wrap">
        <div class="row mb-3">
          <ElLabel name="제목" classNm="col-sm-2 col-form-label">
            <template #end="{id}">
              <div class="col-sm-10">
                <ElInput :id="id" v-model="state.params.title" ref="titleRef"/>
              </div>
            </template>
          </ElLabel>
          
        </div>
        <div class="row mb-3">
          <ElLabel name="작성자" classNm="col-sm-2 col-form-label"/>
          <div class="col-sm-10">
            {{ state.userId }}
          </div>
        </div>
        <div class="row mb-3">
          <ElLabel name="내용" classNm="col-sm-2 col-form-label"/>
            <Editor v-model="state.params.content" editorStyle="height: 320px" ></Editor>
        </div>
      </div>
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="checkValidation()">수정</ElButton>
        <!--
        <ElButton type="primary" @buttonClick="checkValidation('U')">수정</ElButton>
        <ElButton type="primary" @buttonClick="checkValidation('D')">삭제</ElButton>
        -->
      </div>
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              파일첨부
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              {{state.file_seq_grp}}
              <!-- <table>
                <tr></tr>
              </table> -->
              <FileUpload
                ref="fileUploadRef"
                @return="res => getFileList(res)"
                @deleteData="res => getDeleteFile(res)"
              />
            </div>
          </div>
        </div>
      </div>             
    </div>
  </template>
       
<script setup>   
import {reactive,ref,onBeforeMount} from 'vue'
import Editor          from 'primevue/editor';
import { useRouter } from "vue-router";
import FileUpload from '@/components/common/FileUpload.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { nwsSelect, nwsEdit } from '@/api/nws';
import { fileList } from '@/api/file';

const router = useRouter();
const fileUploadRef = ref()
const titleRef = ref();

onBeforeMount(async ()=> {
    let nws_seq = history.state.nws_seq;

    if(nws_seq){
        let param = {
            nws_seq : nws_seq
        }
        try {
            setIsLoading(true)
            const res = await nwsSelect(param)
            let detailCf = res.rtn

            state.params.nws_seq = detailCf.nws_seq
            state.params.title = detailCf.title
            
            state.params.content = detailCf.content

            state.file_seq_grp = detailCf.file_seq_grp

            //첨부파일이 존재할경우 파일리스트 조회api 호출
            if (detailCf.file_seq_grp != '' && detailCf.file_seq_grp != null && detailCf.file_seq_grp != undefined) {
                let apiParam = {
                    file_seq_grp: detailCf.file_seq_grp
                }
                const resFileList = await fileList(apiParam)
                fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
            }
        } catch (err) {
            alert('조회중 에러가 발생했습니다.')
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }else{
        alert('조회되는 News&Notice가 없습니다.조회페이지로 이동합니다.')
        router.push('/cf/MCF_NT_002')
    }
})   

const state = reactive({
    params : {
            nws_seq : '',
            title : '',
            content : '',
            file_seq_grp : '',
            del_yn : 'N',
            attachFileVO : {
                file_div_id : '10',
                file_seq: '',       //추가 된 파일 seq 전송
                del_file_seq: ''    // 삭제해야 할 파일 seq 전송
            }
        },
        tmpFileList: [],
    //파일 첨부 데이터
    fileList : [],      
    delFileList : [],
    file_seq_grp : '', 
    userId : userStore.user.userId,
    pageType : 'insert',
    typeName : ''

})

//첨부파일 및 저장 상태값 확인
const checkValidation = () => {

    ItemValidation();

    //파일 첨부 데이터가 있는지 확인
    let tmpFiles = fileUploadRef.value.state.tmpFileList

    if(tmpFiles.length > 0) {
        //임시파일이 있으면 실제 경로 저장
        fileUploadRef.value.uploadFile()
    } else{ 
        
    RegClick();
    }
}

//업로드 파일 저장 후 실행되는 함수
const getFileList = (res) => {

if(res && res?.length > 0){
    res.map((file)=>{
    state.fileList.push(file.file_seq)
    })

    RegClick()
}else{
    alert('파일 업로드에 실패했습니다.')
}

}


const ItemValidation = () =>{
    let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.
    if (state.params.title.trim() == '') {  
        alert(msg)
        titleRef.value.input.focus()
        return false
    } else if (state.params.content.trim() == '') {
        alert(msg)
        return false
    }
}

const RegClick = async () =>{

    let msg = '수정하시겠습니까?';


    if(state.fileList.length > 0) {
        state.params.attachFileVO.file_seq = state.fileList.toString()
    }

    if(state.delFileList.length > 0){
        state.params.attachFileVO.del_file_seq = state.delFileList.toString()
    }

    
    let newsParams = {
        nws_seq       : state.params.nws_seq,
        title         : state.params.title,
        content       : state.params.content,
        del_yn        : state.params.del_yn,
        attachFileVO  : {
            file_div_id  : state.params.attachFileVO.file_div_id,
            file_seq     : state.params.attachFileVO.file_seq,
            del_file_seq : state.params.attachFileVO.del_file_seq
        }
        
    }
    // 등록, 수정 처리
    if(confirm(msg)) { 
        try {
            setIsLoading(true)
            const res = await nwsEdit(newsParams)
            if(res.code === '0000'){
                alert('수정완료했습니다. 조회 페이지로 이동합니다.')
            }else{
                alert('수정 실패했습니다.다시 시도해주세요')
            }
            router.push({name:'MCF_NT_002'})
        } catch (err) {
            alert("전송 중 에러가 발생하였습니다.");
        } finally {
            setIsLoading(false)
        }
    }
}

</script>
          
  <style scoped>
  div.form-control {
      height: 240px;
      overflow-y: auto;
  }
  </style>